import React from 'react';
import { Colors } from '@common/tokens';
import { SpecialtySelect } from '@institutions/components/specialty-select';
import { Checkbox, Icon, Table } from '@common/components';
type ClinicalSpecialtyType = {
  id: string;
  displayName: string;
  required?: boolean;
};

export function ClinicalSpecialtiesSelect({
  clinicalSpecialties,
  selectedSpecialties,
  setSelectedSpecialties,
  hidden = false,
}: {
  clinicalSpecialties: ClinicalSpecialtyType[];
  selectedSpecialties: ClinicalSpecialtyType[];
  setSelectedSpecialties: (specialties: ClinicalSpecialtyType[]) => void;
  hidden?: boolean;
}) {
  const updateSpecialtyRequired = (id: string): void => {
    const specialty = selectedSpecialties.find(
      (specialty) => specialty.id === id
    );
    if (specialty) {
      specialty.required = !specialty.required;
      setSelectedSpecialties([
        ...selectedSpecialties.filter((specialty) => specialty.id !== id),
        specialty,
      ]);
    }
  };

  const selectSpecialty = (value: string): void => {
    const selectedSpecialty = clinicalSpecialties.find(
      (specialty) => specialty.id === value
    );
    if (selectedSpecialty) {
      const newSpecialty = { ...selectedSpecialty, required: false };
      let newSelectedSpecialties = [...selectedSpecialties, newSpecialty];
      selectedSpecialties.forEach((selectedSpec) => {
        if (selectedSpec.id === value) {
          newSelectedSpecialties = [...selectedSpecialties];
        }
      });
      setSelectedSpecialties(newSelectedSpecialties);
    }
  };

  const removeSpecialty = (id: string): void => {
    setSelectedSpecialties(
      selectedSpecialties.filter((specialty) => specialty.id !== id)
    );
  };

  const selectedSpecialtiesColumns = [
    {
      title: 'Required',
      width: 60,
      dataIndex: 'required',
      render: (_: unknown, record: ClinicalSpecialtyType) => (
        <Checkbox
          checked={record.required}
          onClick={() => updateSpecialtyRequired(record.id)}
        />
      ),
    },
    {
      title: 'Specialty',
      dataIndex: 'displayName',
    },
    {
      title: 'Delete',
      width: 50,
      render: (record: ClinicalSpecialtyType) => (
        <a onClick={() => removeSpecialty(record.id)}>
          <Icon kind="solid" icon="xMark" color="steelDarker" />
        </a>
      ),
    },
  ];

  return (
    <div className="ClinicalSpecialtiesSelect">
      <SpecialtySelect
        onSelect={selectSpecialty}
        label="Specialties"
        required={false}
        placeholder="Select specialties..."
        hidden={hidden}
      />
      {selectedSpecialties.length > 0 && !hidden && (
        <Table
          dataSource={[...selectedSpecialties].sort((a, b) =>
            a.displayName.localeCompare(b.displayName)
          )}
          columns={selectedSpecialtiesColumns}
          rowKey="id"
          pagination={false}
          bordered
          rowClassName="specialtyTableRow"
          className="specialtyTable"
        />
      )}
      <style jsx>{`
        .ClinicalSpecialtiesSelect :global(.specialtyTableRow) {
          background-color: ${Colors.steelLightest};
        }
        .ClinicalSpecialtiesSelect :global(.specialtyTable) {
          margin-bottom: 25px;
        }
      `}</style>
    </div>
  );
}
